/**
 * @generated SignedSource<<c88dcd0b763aa81f7085d28d98f674ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompleteZoomOauthInput = {
  userId: string;
  code: string;
};
export type userCompleteZoomOAuthMutation$variables = {
  input: CompleteZoomOauthInput;
};
export type userCompleteZoomOAuthMutation$data = {
  readonly completeZoomOauth: {
    readonly details: {
      readonly " $fragmentSpreads": FragmentRefs<"userProfileDetailFragment">;
    };
  };
};
export type userCompleteZoomOAuthMutation = {
  variables: userCompleteZoomOAuthMutation$variables;
  response: userCompleteZoomOAuthMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userCompleteZoomOAuthMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompleteZoomOauthPayload",
        "kind": "LinkedField",
        "name": "completeZoomOauth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileDetailConnect",
            "kind": "LinkedField",
            "name": "details",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userProfileDetailFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userCompleteZoomOAuthMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompleteZoomOauthPayload",
        "kind": "LinkedField",
        "name": "completeZoomOauth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileDetailConnect",
            "kind": "LinkedField",
            "name": "details",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roleId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileSettings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultSessionPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zoomDetails",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientLocations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredVideoType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleCalendarSync",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAgreement",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setupCompletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategorisedSpecialities",
                "kind": "LinkedField",
                "name": "specialities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "approaches",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "areasOfExpertise",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "trackingOnlySpecialities",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "clientGroups",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileQuestion",
                "kind": "LinkedField",
                "name": "profileQuestionResponses",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileQuestion",
                    "kind": "LinkedField",
                    "name": "profileQuestion",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "translationKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingApprovedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationApprovedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d73a1d58d7b70817c7483a373bf77d63",
    "id": null,
    "metadata": {},
    "name": "userCompleteZoomOAuthMutation",
    "operationKind": "mutation",
    "text": "mutation userCompleteZoomOAuthMutation(\n  $input: CompleteZoomOauthInput!\n) {\n  completeZoomOauth(input: $input) {\n    details {\n      ...userProfileDetailFragment\n      id\n    }\n  }\n}\n\nfragment userProfileApplicationStatusFragment on UserProfileDetailConnect {\n  onboardingStatus\n  applicationStatus\n  documentStatus\n  profileStatus\n  setupCompletedAt\n  onboardingApprovedAt\n  applicationApprovedAt\n}\n\nfragment userProfileDetailFragment on UserProfileDetailConnect {\n  id\n  type\n  roleId\n  profileInformation\n  profileSettings\n  defaultSessionPassword\n  zoomDetails\n  clientLocations\n  preferredVideoType\n  googleCalendarSync\n  signedAgreement\n  setupCompletedAt\n  specialities {\n    approaches {\n      id\n      name\n    }\n    areasOfExpertise {\n      id\n      name\n    }\n    trackingOnlySpecialities {\n      id\n      name\n    }\n    clientGroups {\n      id\n      name\n    }\n  }\n  profileQuestionResponses {\n    id\n    answer\n    profileQuestion {\n      id\n      translationKey\n      question\n    }\n  }\n  ...userProfileApplicationStatusFragment\n}\n"
  }
};
})();

(node as any).hash = "11d9462838be4dfd6e8f101576047425";

export default node;
